// API Configuration - Central config for all API settings

// Get environment variable with optional default
const getEnvVariable = (key, defaultValue = '') => {
  const value = process.env[key];
  if (!value && !defaultValue) {
    console.warn(`[API Config] Environment variable ${key} is not set`);
  }
  
  return value || defaultValue;
};

// API Base URLs - loaded from environment variables
export const API_BASE_URLS = {
  primary: getEnvVariable('REACT_APP_API_BASE_URL', ''),
  backend: getEnvVariable('REACT_APP_URL_BASE', getEnvVariable('REACT_APP_BACKEND_API_URL', '')),
  aiServices: getEnvVariable('REACT_APP_AI_SERVICES_URL', getEnvVariable('REACT_APP_AI_SERVICES_URL', '')),
  dataTriage: getEnvVariable('REACT_APP_DATA_TRIAGE_URL', getEnvVariable('REACT_APP_DATA_TRIAGE_URL', '')),
  storage: getEnvVariable('REACT_APP_STORAGE_API_URL', ''),
  msGraph: 'https://graph.microsoft.com/v1.0',
};

// Timeout configuration (in milliseconds)
// Set to 0 to disable timeouts (allows long-running requests)
export const API_TIMEOUTS = {
  default: 230000,
  upload: 0,
  longRunning: 230000,
  healthCheck: 5000,
};

// Retry configuration
export const API_RETRY_CONFIG = {
  maxRetries: 3,
  retryDelay: 1000,
  retryableStatuses: [408, 429, 500, 502, 503, 504],
};

// API version paths
export const API_VERSIONS = {
  v1: '/api/v1',
  v2: '/api/v2',
  current: '/api/v1',
};

// Pagination defaults
export const PAGINATION_DEFAULTS = {
  page: 1,
  limit: 20,
  maxLimit: 100,
};

// Get full API URL with version
export const getApiUrl = (baseUrlKey = 'primary', version = API_VERSIONS.current) => {
  const baseUrl = API_BASE_URLS[baseUrlKey] || API_BASE_URLS.primary;
  
  // Remove trailing slash from base URL if present
  const cleanBaseUrl = baseUrl.replace(/\/$/, '');
  
  return `${cleanBaseUrl}${version}`;
};

export default {
  API_BASE_URLS,
  API_TIMEOUTS,
  API_RETRY_CONFIG,
  API_VERSIONS,
  PAGINATION_DEFAULTS,
  getApiUrl,
};
